import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FeesRestService } from '@api-module/rest/fees.rest.service';
import { AutoSweepConstant } from 'src/app/share/constants/auto-sweep.constant';
import { TranslateService } from '@ngx-translate/core';
import { AppConstant } from "@constant";

@Injectable({
	providedIn: 'root'
})
export class AutoSweepService {
    private managementFee = AutoSweepConstant.AS_MANAGEMENT_FEE;
    
	constructor(
			private feesRestService: FeesRestService,
			private translateService: TranslateService,
		) 
	{
		this.feesRestService.getAsManagementFee('HKD').subscribe((res:any) => {
			if(AppConstant.RESPONSE_SUCCESS === res.status && res.data!=null){
				this.managementFee = res.data;
			}
		});
	}
	
	getManagementFee() {
		return this.managementFee;
	}

	updateAsManagementFee(key:string, fallback?:string) {
		let interpolateParams = {asManagementFee : this.managementFee};
		
		let translation = this.translateService.instant(key, interpolateParams);
		
		if (translation == key && fallback != null) {
			translation = fallback;
		}
		
		return translation;
	}




}